import {AxiosError} from 'axios';
import {POST_CANDIDATE_SEARCH_NO_PAGINATION_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {ApiPathParam} from "../../models/SearchParamSchema";
import {PaginatedData} from "../../models/List";
import {GenericErrorResponse} from "../typings";

export interface Candidate {
  uinFinPassport: string;
  candidateName: string;
  email: string;
  school: string;
  uuid: string;
}

export interface CandidateSearchNoPageRequest {
  q: string;
  apiParams: ApiPathParam;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<Candidate>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;

}

export const usePostCandidateSearchNoPagination = ({onSuccess, onError}: Input = {}) => {
  const postCandidateSearch = async (requestBody: CandidateSearchNoPageRequest) => {
    const res = await axiosClient.post<PaginatedData<Candidate>>(
      POST_CANDIDATE_SEARCH_NO_PAGINATION_URL(requestBody.apiParams),
      requestBody
    );

    return res.data;
  };

  return useCustomMutation(postCandidateSearch, {
    onSuccess,
    onError,
  });
};
